import { createFileRoute } from "@tanstack/react-router";

import FederationPage from "./-components/FederationPage";

export const Route = createFileRoute(
  "/_app/_dashboard/federatedaccess/$federatedUserId"
)({
  component: FederationPage,
});
